/* eslint-disable import/no-anonymous-default-export */

export const base64Encode = (plain) => window.btoa(plain);

export const base64Decode = (encoded) => window.atob(encoded);

export default { base64Encode, base64Decode };
